import { pgTable, integer, varchar, timestamp, index } from 'drizzle-orm/pg-core';
import { sql } from 'drizzle-orm';

export const emailOtp = pgTable('EmailOtp', {
  id: integer().primaryKey().generatedAlwaysAsIdentity(),
  email: varchar({ length: 255 }).notNull(),
  code: varchar({ length: 64 }).notNull(),
  attempts: integer().default(0).notNull(),
  purpose: varchar({ length: 20 }).default('auth').notNull(),
  expiresAt: timestamp({ precision: 3, mode: 'date' }).notNull(),
  createdAt: timestamp({ precision: 3, mode: 'date' }).default(sql`CURRENT_TIMESTAMP`).notNull(),
}, (table) => [
  index('email_otp_email_expires_idx').on(table.email, table.expiresAt),
  index('email_otp_email_purpose_idx').on(table.email, table.purpose),
]);
